/*
|--------------------------------------------------------------------------
| Aham Jewellery Custom Code
|--------------------------------------------------------------------------
| File: aham-video-gallery.js
| Purpose: Product image/video gallery enhancements
| Theme: Shopify Debut 2.2
|--------------------------------------------------------------------------
*/

document.addEventListener("DOMContentLoaded", function () {

  function pauseAllVideos() {
    document.querySelectorAll(".product-single__photo video").forEach(function (video) {
      video.pause();
    });
  }

  // ----------------------------
  // VIDEO THUMBNAIL CLICK
  // ----------------------------

  document.addEventListener("click", function (e) {

    var videoThumb = e.target.closest(".aham-video-thumb");

    if (!videoThumb) {
      return;
    }

    e.preventDefault();

    pauseAllVideos();

    // Hide every media wrapper
    document.querySelectorAll(".product-single__photo-wrapper").forEach(function (wrapper) {
      wrapper.classList.add("hide");
    });

    var videoId = videoThumb.getAttribute("data-video-id");

    var videoPhoto = document.querySelector(
      '.product-single__photo[data-media-id="' + videoId + '"]'
    );

    if (!videoPhoto) {
      console.log("Video not found");
      return;
    }

    // Show wrapper
    if (videoPhoto.parentElement) {
      videoPhoto.parentElement.classList.remove("hide");
    }

    // Show video container
    videoPhoto.classList.remove("hide");

    // Play video
    var video = videoPhoto.querySelector("video");

    if (video) {
      video.currentTime = 0;
      video.play();
    }

  });

  // ----------------------------
// IMAGE THUMBNAIL CLICK
// ----------------------------

document.addEventListener("click", function (e) {

  var imageThumb = e.target.closest(".product-single__thumbnail");

  if (!imageThumb) return;

  if (imageThumb.classList.contains("aham-video-thumb")) return;

  pauseAllVideos();

  // Hide video
  document.querySelectorAll('.product-single__photo[data-media-id]').forEach(function(videoPhoto){

      videoPhoto.classList.add("hide");

      if(videoPhoto.parentElement){
          videoPhoto.parentElement.classList.add("hide");
      }

  });

  // Show image wrappers again
  document.querySelectorAll(".product-single__photo-wrapper").forEach(function(wrapper){

      if(wrapper.querySelector("img")){
          wrapper.classList.remove("hide");
      }

  });

});

});